import { render, staticRenderFns } from "./assetWorth.vue?vue&type=template&id=c6c10ed0&scoped=true&"
import script from "./assetWorth.vue?vue&type=script&lang=js&"
export * from "./assetWorth.vue?vue&type=script&lang=js&"
import style0 from "./assetWorth.vue?vue&type=style&index=0&id=c6c10ed0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c10ed0",
  null
  
)

export default component.exports